<template>
  <div class="course-mp">
    <div class="page-title">{{ $t('lang.classInfo') }}</div>
    <div class="card course-info-card" :class="{ openCard: lessonInfo.courseType === 1 }">
      <div class="label-salary">
        <span v-if="lessonInfo.courseType === 0" class="label">1v1</span>
        <span v-if="lessonInfo.courseType === 2" class="label label-1vn">1vN</span>
        <span v-if="lessonInfo.courseType === 1" class="label label-open">{{ $t("lang.openClass") }}</span>
        <div v-if="lessonInfo.salary" class="salary">
          {{ $t("lang.payment") }}<span class="num">{{ lessonInfo.currency.toLowerCase() === 'usd' ? '$' : '¥' }}{{ lessonInfo.salary }}</span>
        </div>
      </div>
      <div v-if="lessonInfo.courseType === 0" class="stu-info-1v1">
        <div class="avatar">
          <img :src="lessonInfo.childAvatar">
        </div>
        <div class="stu-name">{{ lessonInfo.students[0] }}</div>
      </div>
      <div v-if="lessonInfo.courseType === 2" class="stu-info-1vn">
        <div class="avatar-group">
          <div v-if="lessonInfo.childrenAvatar[0]" class="avatar avatar-1">
            <img :src="lessonInfo.childrenAvatar[0]">
          </div>
          <div v-if="lessonInfo.childrenAvatar[1]" class="avatar avatar-2">
            <img :src="lessonInfo.childrenAvatar[1]">
          </div>
          <div v-if="lessonInfo.childrenAvatar[2]" class="avatar avatar-3">
            <img :src="lessonInfo.childrenAvatar[2]">
          </div>
          <div v-if="lessonInfo.childrenAvatar[3]" class="avatar avatar-4">
            <img :src="lessonInfo.childrenAvatar[3]">
          </div>
          <div v-if="lessonInfo.childrenAvatar[4]" class="avatar avatar-5">
            <img :src="lessonInfo.childrenAvatar[5]">
          </div>
          <div v-if="lessonInfo.childrenAvatar[5]" class="avatar avatar-6">
            <img :src="lessonInfo.childrenAvatar[5]">
          </div>
        </div>
        <div class="stu-num">{{ lessonInfo.childrenAvatar.length }}人</div>
      </div>
      <div v-if="lessonInfo.courseType === 1 && lessonInfo.childrenAvatar" class="stu-info-1vn">
        <div class="avatar-group">
          <div v-if="lessonInfo.childrenAvatar[0]" class="avatar avatar-1">
            <img :src="lessonInfo.childrenAvatar[0]">
          </div>
          <div v-if="lessonInfo.childrenAvatar[1]" class="avatar avatar-2">
            <img :src="lessonInfo.childrenAvatar[1]">
          </div>
          <div v-if="lessonInfo.childrenAvatar[2]" class="avatar avatar-3">
            <img :src="lessonInfo.childrenAvatar[2]">
          </div>
          <div v-if="lessonInfo.childrenAvatar[3]" class="avatar avatar-4">
            <img :src="lessonInfo.childrenAvatar[3]">
          </div>
          <div v-if="lessonInfo.childrenAvatar[4]" class="avatar avatar-5">
            <img :src="lessonInfo.childrenAvatar[5]">
          </div>
          <div v-if="lessonInfo.childrenAvatar[5]" class="avatar avatar-6">
            <img :src="lessonInfo.childrenAvatar[5]">
          </div>
        </div>
        <div class="stu-num">{{ lessonInfo.students.length }}人</div>
      </div>
      <div class="start-time">
        <span class="title">{{ $t("lang.time") }}</span>
        <span class="ctx">{{ language = 'en' ? $utils.formatLocalTimeYYYYMMDDdddHHmm(lessonInfo.startTime, timeZone) : $utils.formatCNTimeYYYYMMDDdddHHmm(lessonInfo.startTime, timeZone) }}</span>
      </div>
      <div class="course-name">
        <span class="title">{{ $t("lang.course") }}</span>
        <span class="ctx">{{ lessonInfo.level }}</span>
      </div>
      <div class="lesson-name">
        <span class="title">{{ $t("lang.unit") }}</span>
        <span class="ctx">{{ lessonInfo.title }}</span>
      </div>
      <div class="class-url">
        <span class="title">{{ $t("lang.classURL") }}</span>
        <span class="ctx">{{ roomUrl }}</span>
        <button class="copy-link" v-clipboard="roomUrl" @success="handleCopySuccess">{{ $t("lang.copyLink") }}</button>
      </div>
    </div>
    <div class="card remark-card">
      <div class="title">{{ $t("lang.notes") }}</div>
      <div class="remark">{{ !lessonInfo.remark ? $t("lang.nothingYet") : lessonInfo.remark }}</div>
    </div>
    <div class="card pdf-card">
      <div class="title">{{ $t("lang.lessonPreview") }}</div>
      <div class="courseware-pdf">
        <div class="courseware-pdf-status" v-if="!loaded">
          loading...
        </div>
        <div v-if="pageUrlBase" class="courseware-img">
          <v-touch v-on:swipeleft="nextPdf" v-on:swiperight="prevPdf">
            <img v-lazy="`${pageUrlBase + page + imgFormat}`" />
          </v-touch>
        </div>
        <div class="no-data" v-else>
          {{ $t("lang.classRoom5") }}
        </div>
        <div
          class="button-prev button-navigation"
          :class="page === 1 && 'button-disabled'"
          @click="prevPdf($event)"
          v-if="pageUrlBase"
        >
          <i class="el-icon-arrow-left"></i>
        </div>
        <div class="page-forward" v-if="pageUrlBase">
          <div class="page-box">
            <div class="totlePage" v-if="numPages">{{ page }} / {{ numPages }}</div>
          </div>
        </div>
        <div
          class="button-next button-navigation"
          :class="page === numPages && 'button-disabled'"
          @click="nextPdf($event)"
          v-if="pageUrlBase"
        >
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
    <el-dialog
      class="copy-dialog"
      :show-close="false"
      :center="true"
      :width="'80vw'"
      :top="'28vh'"
      :visible.sync="copyLinkVisible"
    >
      <div class="icon-success"></div>
      <div class="tip">{{ $t("lang.copySuccess") }}</div>
    </el-dialog>
  </div>
</template>

<script>
import { ERR_OK } from "api/config";
import { findLessonByLessonId } from '@/api/course.js'
// import moment from "moment-timezone";
import { getDocPages } from "api/course";

export default {
  data () {
    return {
      lessonInfo: {},
      lessonId: this.$route.query.lessonId,
      // timeZone: moment.tz.guess(),
      timeZone: localStorage.getItem('timeZone') ? localStorage.getItem('timeZone') : 'Asia/Shanghai',
      SlideNoteParma: {
        lessonId: this.$route.query.lessonId
          ? Number.parseInt(this.$route.query.lessonId)
          : ""
      },
      pageArr: [],
      tmpPageArr: [],
      pageUrlBase: "",
      imgFormat: "",
      page: 1,
      numPages: 1,
      loaded: false,
      language: '',
      copyLinkVisible: false,
      roomUrl: this.$route.query.roomUrl ? decodeURIComponent(this.$route.query.roomUrl) : ''
    }
  },
  created () {
    this.setLanguage()
    this.getLessonInfo()
    this._getDocPages()
  },
  methods: {
    getLessonInfo() {
      findLessonByLessonId({lessonId: this.lessonId})
        .then((response) => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              this.lessonInfo = response.data.data;
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch((e) => {
          this.$message.error(e.message);
        });
    },
    _getDocPages() {
      getDocPages(this.SlideNoteParma)
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === +ERR_OK) {
              this.pageUrlBase = response.data.data.pageUrlBase;
              this.imgFormat = response.data.data.imgFormat;
              this.numPages = +response.data.data.totalPageSize;
              this.loaded = true;
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },
    handleCopySuccess() {
      this.copyLinkVisible = true
      setTimeout(() => {
        this.copyLinkVisible = false
      }, 1000);
    },
    prevPdf(event) {
      if (this.page > 1) {
        this.page--;
      }
    },
    nextPdf(event) {
      if (this.page < this.numPages) {
        this.page++;
      }
    },
    setLanguage() {
      this.language = this.$i18n.locale
    }
  }
}
</script>

<style lang="scss">
.course-mp {
  display: flex;
  flex-direction: column;
  max-width: 750px;
  padding: 0 4vw;
  height: 100vh;
  margin: 0 auto;
  font-size: 15px;
  color: #000000;
  background: #f9f9f9;

  .card {
    // display: flex;
    // flex-direction: column;
    margin-bottom: 10px;
    padding: 10px;
    font-size: 16px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.07);
  }

  .page-title {
    margin: 20px 0;
    font-weight: 500;
  }

  .course-info-card {
    .label-salary {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
    }

    .label {
      width: 56px;
      height: 22px;
      border-radius: 4px;
      text-align: center;
      line-height: 22px;
      background: #ffdd02;
    }

    .label-1vn {
      background: #87B2EC;
    }

    .label-open {
      background: #ED6D59;
    }

    .salary {
      color: #000000;
      font-size: 16px;

      .num {
        color: #ED6D59;
      }
    }

    .stu-info-1v1 {
      .avatar {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        overflow: hidden;

        img {
          height: 100%;
        }
      }

      .stu-name {
        margin: 11px auto 33px;
        text-align: center;
        font-weight: 500;
      }
    }

    .stu-info-1vn {
      display: flex;
      align-items: center;
      margin: 18px 0 24px;

      .avatar-group {
        position: relative;
        height: 50px;
        margin-left: 18px;
      }

      .avatar {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        overflow: hidden;

        img {
          width: 48px;
          height: 48px;
        }
        &-1 {
          left: 0px;
          z-index: 10;
        }

        &-2 {
          left: calc(34px * 1);
          z-index: 11;
        }

        &-3 {
          left: calc(34px * 2);
          z-index: 13;
        }

        &-4 {
          left: calc(34px * 3);
          z-index: 14;
        }

        &-5 {
          left: calc(34px * 4);
          z-index: 15;
        }

        &-6 {
          left: calc(34px * 5);
          z-index: 16;
        }
      }

      .stu-num {
        color: #4A4A4A;
        font-size: 14px;
        margin-left: auto;
        margin-right: 10px;
      }
    }

    .start-time,
    .course-name,
    .lesson-name,
    .class-url {
      margin-bottom: 28px;

      .title {
        color: #4A4A4A;
        margin: 0 20px 0 10px;
      }
    }

    .class-url {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      height: 30px;

      .ctx {
        width: 160px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .title {
        color: #4A4A4A;
        margin: 0 10px 0 10px;
      }

      .copy-link {
        width: 45px;
        height: 26px;
        margin-left: auto;
        padding: 0 4px;
        border: none;
        border-radius: 5px;
        background: #FFDA5C;
        font-size: 12px;
        text-align: center;
        line-height: 26px;
        outline: none;
      }
    }
  }

  .remark-card {
    padding: 10px 20px;

    .title {
      margin-bottom: 13px;
      color: #4A4A4A;
    }

    .remark {
      white-space: pre-wrap;
    }
  }

  .pdf-card {
    .title {
      margin: 3px auto 10px;
      color: #4A4A4A;
      text-align: center;
    }
  }

  .courseware-pdf {
    width: 100%;
    border-radius: 6px;
    position: relative;
    margin: 0 auto 50px;
    background: #f5f5f5;
    .courseware-img {
      position: relative;
      img {
        display: block;
        width: 100%;
      }
    }
    .courseware-pdf-status {
      position: absolute;
      width: 100%;
      height: 450px;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 9;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      font-size: 20px;
      color: #ffa438;
      background: #fff;
    }
    .swiper-container {
      height: 100%;
    }
    .button-navigation {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #FFDA5C;
      color: #373634;
      font-size: 12px;
      text-align: center;
      position: absolute;
      bottom: -43px;
      border-radius: 50%;
      z-index: 9;
      cursor: pointer;
    }
    .button-next {
      right: 50%;
      transform: translateX(60px);
    }
    .button-prev {
      left: 50%;
      transform: translateX(-60px);
    }
    .button-disabled {
      background: #dedede;
    }
    .page-forward {
      height: 26px;
      line-height: 24px;
      text-align: center;
      position: absolute;
      bottom: -43px;
      left: 50%;
      transform: translateX(-50%);
      .page-box {
        display: inline-block;
        width: 48px;
        height: 24px;
        outline: 0;
        padding: 0px 10px;
        text-align: center;
        position: relative;
        z-index: 9;
        .totlePage {
          position: absolute;
          height: 24px;
          line-height: 24px;
          right: 15px;
          top: 0px;
          color: #4A4A4A;
          font-size: 14px;
          font-weight: 500;
        }
      }
      .page-forward-btn {
        display: inline-block;
        width: 48px;
        height: 24px;
        line-height: 24px;
        background: rgba(255, 164, 56, 0.5);
        color: #333;
        border: 1px solid burlywood;
        text-align: center;
        border-radius: 20px;
        margin-left: 10px;
        cursor: pointer;
        font-size: 12px;
      }
    }
  }

  .copy-dialog {
    .el-dialog {
      border-radius: 10px !important;
    }

    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #4A4A4A;
      font-size: 14px;
      font-weight: 500;
    }

    .icon-success {
      height: 32px;
      width: 32px;
      background: url(~assets/images/Icon-copy-success.png) center center no-repeat;
      background-size: contain;
    }

    .tip {
      margin-top: 16px;
    }
  }

  .openCard {
  }
}
</style>



// WEBPACK FOOTER //
// src/views/h5/course-mp.vue